'use client'

import {Charts} from './Charts';
import PaymentChartsDataProvider from './contexts/PaymentsChartsContext';

const PaymentsWrapper = () => {
    return (
        <PaymentChartsDataProvider>
            <Charts />
        </PaymentChartsDataProvider>
    );
};

export default PaymentsWrapper;
